import { cn } from "@/lib/utils";

/**
 * Icon-only controls on active-filter chips: below `sm` the hit area and glyphs are enlarged
 * for touch; from `sm` up they stay compact to match dense table chrome.
 */
export const activeFiltersSummaryChipVisibilityButtonClassName = cn(
  "size-10 shrink-0 rounded-full text-muted-foreground hover:bg-muted sm:size-5",
  "[&_svg]:size-[1.125rem] sm:[&_svg]:size-3",
);

export const activeFiltersSummaryChipRemoveButtonClassName = cn(
  "size-10 shrink-0 rounded-full text-muted-foreground hover:bg-destructive/10 hover:text-destructive sm:size-5",
  "[&_svg]:size-4 sm:[&_svg]:size-2.5",
);
